import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoginForm } from "@/components/auth/login-form";
import { useAuthStore } from "@/stores/auth-store";

type LoginSearch = {
  redirect?: string;
  /** Set after accepting an invitation, to confirm the password was saved. */
  invited?: string;
};

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect:
      typeof search.redirect === "string" ? search.redirect : undefined,
    invited: typeof search.invited === "string" ? search.invited : undefined,
  }),
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated()) {
      throw redirect({ to: "/app" });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { invited } = Route.useSearch();
  return <LoginForm invitedEmail={invited} />;
}
